<template>
  <div>
    <div v-if="isLoading && data === null" class="uk-flex uk-flex-column">
      <small-slims-loader></small-slims-loader>
    </div>

    <div v-if="data !== null" v-for="item in data" :value="item">
      <div>
        <comp-sales-metric :yesterday-dates="yesterdayDates" :rolling7-dates="rolling7Dates" :period-dates="periodDates" :ytd-dates="ytdDates" :comp-data="item"></comp-sales-metric>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import SmallSlimsLoader from "./Components/SmallSlimsLoader";
import CompSalesMetric from "./Components/CompSalesMetric";
import SmallLoaderComponent from "../../../Assets/js/Shared/SmallLoaderComponent.vue";
import HelpInfo from "../../../Assets/js/Shared/HelpInfo.vue";

export default {
  name: "CompSalesCard",
  components: {
    SmallLoaderComponent,
    SmallSlimsLoader,
    HelpInfo,
    CompSalesMetric
  },

  props: {
    yesterdayDates: Array,
    rolling7Dates: Array,
    periodDates: Array,
    ytdDates: Array
  },


  data() {
    return {
      isLoading: false,
      data: null
    }
  },

  mounted() {

    this.isLoading = true;
    let me = this;
    const token = this.getTokenSilently();
    const url = this.getApiUrl();
    const clientId = this.getClientId();

    //Franchise
    axios.get(`${url}/api/slims-report/franchise/comp-kpi-data`, {
      headers: {Authorization: `Bearer ${token}`},
      params: {
        metric: 'Netsales',
        clientId: clientId
      }
    })
        .then(response => {
          me.data = response.data;
        })
        .catch(err => {
        })
        .finally(() => {
          this.isLoading = false;
        });
  }
}
</script>

<style scoped>


</style>